import { Tabs, TabsProps } from 'antd';
import classNames from 'classnames';
import { useMemo, useState } from 'react';

import { Breakpoints, useMediaQuery } from '@/hooks/useMediaQuery';

import './VerticalTabs.scss';

interface Props extends TabsProps {
  className?: string;
  containerClassName?: string;
}

export const VerticalTabs: React.FC<Props> = ({
  items,
  containerClassName,
  className,
  defaultActiveKey = '1',
  onChange,
  activeKey,
  ...props
}) => {
  const [isTabsOpen, setIsTabsOpen] = useState<boolean>(false);
  const [currentActiveKey, setCurrentActiveKey] = useState<string>(activeKey ?? '');
  const currentActiveTab = useMemo(
    () => (currentActiveKey ? items?.find((item) => item.key === currentActiveKey) : items![0]),
    [currentActiveKey, items],
  );
  const isMobileSize = useMediaQuery(Breakpoints.LG);

  return (
    <div data-testid="vertical-tabs-container" className={classNames('custom-vertical-tabs', containerClassName)}>
      {isMobileSize && (
        <button
          className="custom-vertical-tabs__click-place"
          onClick={(): false | void => setIsTabsOpen(!isTabsOpen)}
        />
      )}
      <Tabs
        {...props}
        className={classNames('custom-vertical-tabs__tabs', { 'list-opened': isTabsOpen }, className)}
        data-testid="vertical-tabs"
        defaultActiveKey={defaultActiveKey}
        items={
          isMobileSize
            ? isTabsOpen || !currentActiveTab
              ? items?.sort((tab1, tab2) =>
                  tab1.key === currentActiveKey ? -1 : tab2.key === currentActiveKey ? 1 : 0,
                )
              : [currentActiveTab]
            : items
        }
        onChange={(activeKey): void => {
          isMobileSize && setIsTabsOpen(false);
          setCurrentActiveKey(activeKey);
          onChange && onChange(activeKey);
        }}
        tabPosition="left"
      />
    </div>
  );
};
